import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import OptimizedImage from '../Redesign/OptimizedImage';
import largeRiottLogo from 'url:../../assets-optimized/redesign/large_riott_logo.png';
import largeRiottLogoavif from 'url:../../assets-optimized/redesign/large_riott_logo.avif';
import largeRiottLogowebp from 'url:../../assets-optimized/redesign/large_riott_logo.webp';

const Footer = () => {
  const navColumns = [
    [
      { label: 'Home', to: '/' },
      { label: 'Contact', to: '/contact' },
    ],
    [
      { label: 'Marriott Digital', to: '/solutions/marriott-digital' },
      { label: 'Offsite Digital', to: '/solutions/offsite-digital' },
      { label: 'On-Property', to: '/solutions/on-property' },
    ],
    [
      { label: 'Partner Stories', to: '/partner-stories' },
      // { label: 'Insights', to: '/insights' },
      { label: 'Our Platform', to: '/our-platform' },
    ],
  ];

  const linkList = [
    { raw: <li id='teconsent'></li> },
    {
      label: 'Terms of Use',
      url: 'https://www.marriott.com/about/terms-of-use.mi',
    },
    {
      label: 'Program Terms & Conditions',
      url: 'https://www.marriott.com/loyalty/terms/default.mi',
    },
    {
      label: 'Privacy Center',
      url: 'https://www.marriott.com/about/privacy.mi',
    },
    { raw: <li id='ccpacontainer'></li> },
    {
      label: 'Digital Accessibility',
      url: 'https://www.marriott.com/digital-accessibility.mi',
    },
    {
      label: 'Help',
      url: 'https://help.marriott.com/s',
    },
  ];

  return (
    <footer className='redesign-footer'>
      <div className='footer-logo'>
        <OptimizedImage
          avif={largeRiottLogoavif}
          webp={largeRiottLogowebp}
          fallback={largeRiottLogo}
          alt='Marriott Media'
        />
      </div>
      <div className='footer-content'>
        <div className='footer-directory'>
          {navColumns.map((column, columnIndex) => (
            <div className='footer-directory-column' key={columnIndex}>
              <ul className='footer-directory-list'>
                {column.map((item) => (
                  <li key={item.to}>
                    <Link to={item.to}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className='footer-social'>
          <a
            href='https://www.linkedin.com/company/marriott-media/'
            className='linkedin-btn'
            target='_blank'
            rel='noopener noreferrer'
          >
            Follow us on LinkedIn
            <span className='sr-only'> (opens in a new tab)</span>
            <svg
              className='linkedin-icon'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
              aria-hidden='true'
            >
              <circle cx='12' cy='12' r='12' fill='white' />
              <path
                d='M8.25 17.5H5.75V9.5H8.25V17.5ZM7 8.25C6.17 8.25 5.5 7.58 5.5 6.75C5.5 5.92 6.17 5.25 7 5.25C7.83 5.25 8.5 5.92 8.5 6.75C8.5 7.58 7.83 8.25 7 8.25ZM18.5 17.5H16V13.5C16 12.55 15.95 11.25 14.5 11.25C13 11.25 12.75 12.4 12.75 13.4V17.5H10.25V9.5H12.65V10.6H12.7C13.05 9.95 13.9 9.3 15.15 9.3C17.75 9.3 18.5 11 18.5 13.15V17.5Z'
                fill='#1c1c1c'
              />
            </svg>
          </a>
        </div>

        <div className='footer-divider'></div>

        <div className='footer-copyright'>
          © 1996 - 2025 Marriott International, Inc. All rights reserved. Marriott Proprietary
          Information.
        </div>
        <ul className='footer-links'>
          {linkList.map((link, index) => {
            const isLast = index === linkList.length - 1;
            return link.raw ? (
              React.cloneElement(link.raw, {
                className: isLast ? 'footer-link' : 'footer-link footer-link-separator',
                key: index,
              })
            ) : (
              <li
                className={isLast ? 'footer-link' : 'footer-link footer-link-separator'}
                key={index}
              >
                {link.url ? (
                  <a
                    href={link.url}
                    className='custom_click_track'
                    data-custom_click_track_value={`Footer|${typeof link.label === 'string' ? link.label : 'Privacy Choices'}|External|`}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {link.label}
                    <span className='sr-only'> (opens in a new tab)</span>
                  </a>
                ) : (
                  <span
                    className='custom_click_track'
                    data-custom_click_track_value='Footer|Tracking Preferences|Internal|'
                  >
                    {link.label}
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
